// extracted by mini-css-extract-plugin
export default {"container":"list_container__DpRO9","subtitle":"list_subtitle__1_Yo-","bullets":"list_bullets__3p88d","bullet":"list_bullet__1EUa1"};